export default "__VITE_ASSET__5dqSYtf1__"